<template>
  <section>
    <!-- <a href="" target="_blank" rel="noopener noreferrer"><img src="/static/images/topguanggao.png" alt="" srcset="" class="topguanggao"></a>
    <Header :indexData="indexData" :userInfo="userInfo" :keyword="keyword"></Header>
 
    <Footer :indexData="indexData"></Footer>-->
    <div id="login">
      <div class="header">
        <div class="container">
          <div class="logo">
            <a href="/">
              <img src="/static/images/logo.png" />
            </a>
          </div>
        </div>
      </div>
      <div class="logincontent">
        <div class="container">
          <form action lay-filter="login" class="layui-form">
            <div class="loginbox">
              <div class="hd">密码登录</div>
              <div class="row">
                <div class="icon">
                  <img src="/static/images/icon_user.png" />
                </div>
                <div class="cont">
                  <input
                    type="text"
                    placeholder="会员名"
                    name="username"
                    lay-verify="required" autocomplete='off'
                    v-model="username"
                  />
                </div>
              </div>
              <div class="row">
                <div class="icon">
                  <img src="/static/images/icon_pwd.png" />
                </div>
                <div class="cont">
                  <input
                    type="password"
                    placeholder="密码"
                    name="userpwd"
                    lay-verify="required"
                    v-model="userpwd"  autocomplete='off'
                  />
                </div>
              </div>
              <div style="margin-top: 30px;">
                <button
                  type="button"
                  lay-submit
                  lay-filter="login"
                  class="layui-btn layui-btn-fluid primary_bg"
                  @click="submituser"
                >登录</button>
              </div>
              <div class="mt20 text-right" style="font-size: 12px;">
                <a href="#/findpwd" style="margin-right: 15px;">忘记密码</a>
                <router-link to="/register">
                  <a href="javascript;,">免费注册</a>
                </router-link>
              </div>
            </div>
          </form>
        </div>
      </div>

      <div class="container loginfooter">
        <div class="link">
          <span v-for="(item,index) in indexData.index_link_bottom">
            <a :href="item.url">{{item.remark}}</a>
            {{index < indexData.index_link_bottom.length-1 ? "|" : ""}}
          </span>
        </div>
        <div class="mt10" v-html="indexData.index_copyright"></div>
      </div>
    </div>
  </section>
</template>

<script>
import Header from "../components/header";
import Footer from "../components/footer";
export default {
  components: {
    Header,
    Footer
  },
  name: "login",
  data() {
    return {
      indexData: {
        index_cartnum: 0,
        index_shop_self: {
          adlist: [{ url: "", src: "" }, { url: "", src: "" }]
        }
      },
      oldUrl: "",
      userpwd: "",
      username: ""
    };
  },
  created() {
    this.keyupSubmit();
  },
  methods: {
    keyupSubmit() {
      document.onkeydown = e => {
        let _key = window.event.keyCode;
        if (_key == 13) {
          this.submituser();
        }
      };
    },
    async submituser() {
      let that = this;
      if (!this.username || this.username == " ") {
        that.$message.error("请输入用户名");
        return;
      }
      if (!this.userpwd || this.userpwd == " ") {
        that.$message.error("请输入密码");
        return;
      }
      let submitData = { username: this.username, userpwd: this.userpwd };
      let result = await that.$fetch("login/login", { body: submitData });
      if (!result) return;
      that.$message.success("登录成功");
      sessionStorage.guid = result.guid;
      localStorage.jinruser = JSON.stringify(result.user);
      sessionStorage.user = localStorage.jinruser;
      setCookie("guid", result.guid, 2);
      if (
        window.history.length <= 1 ||
        that.oldUrl == "/register" ||
        that.oldUrl == "/findpwd"
      ) {
        that.$router.push({ path: "/" });
        return false;
      } else {
        console.log("window.history", window.history);
        that.$router.go(-1);
      }

    },

  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      // 通过 `vm` 访问组件实例,将值传入oldUrl
      vm.oldUrl = from.path;
    });
  },
  async mounted() {
    delCookie("guid");
    sessionStorage.guid = "";
    localStorage.jinruser = "";
    sessionStorage.user = "";
    //   setCookie("guid", '', 2);
    this.indexData = await this.$fetch("Index/indexdata");
    // console.log("res",res)
    // this.someconfig();
    this.$nextTick(() => {
      // 验证是否获取到了上页的url
      /* eslint-disable no-console */
      console.log(11, this.oldUrl);
    });
  }
};
</script>


<style lang='scss' scoped>
</style>



// WEBPACK FOOTER //
// src/pages/login.vue